import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from '../../atomicComponents';
import styles from './CsvUploader.module.css';
import CsvPreview from '../CsvPreview/CsvPreview';
import { readExcel } from '../../utils/utils';

const CsvUploader = ({
  buttonName,
  disabled,
  id,
  backButtonName,
  formName,
  csvDataFormatter,
  handleSubmit,
  headerConfiguration,
  headersWithJsonFields,
  requiredParams,
  validCsvHeaders,
  addNewRowFormName,
  editRowFormName,
  formItem,
  addNewRowSuccessMessage,
  editRowSuccessMessage,
}) => {
  const [isCsvPreviewOpen, setIsCsvPreviewOpen] = useState(false);
  const [csvFileData, setCsvFileData] = useState([]);

  return (
    <>
      <span className={styles.inputTagWrapper}>
        <Button
          className={styles.uploadCsvButton}
          disabled={disabled}
          data-testid={id}
        >
          <span>{buttonName}</span>
          <input
            className={styles.input}
            type="file"
            id="upload-csv"
            accept=".csv"
            onClick={e => {
              e.stopPropagation();
            }}
            onChange={e => {
              const elem = e.target;
              readExcel(elem.files[0], setCsvFileData, csvDataFormatter);
              setIsCsvPreviewOpen(true);
              elem.value = ''; // reset input element
            }}
            disabled={disabled}
            aria-label="upload"
          />
        </Button>
      </span>
      <CsvPreview
        open={isCsvPreviewOpen}
        setIsCsvPreviewOpen={setIsCsvPreviewOpen}
        backButtonName={backButtonName}
        formName={formName}
        csvDataFormatter={csvDataFormatter}
        handleSubmit={handleSubmit}
        headerConfiguration={headerConfiguration}
        headersWithJsonFields={headersWithJsonFields}
        requiredParams={requiredParams}
        validCsvHeaders={validCsvHeaders}
        csvFileData={csvFileData}
        setCsvFileData={setCsvFileData}
        addNewRowFormName={addNewRowFormName}
        editRowFormName={editRowFormName}
        formItem={formItem}
        addNewRowSuccessMessage={addNewRowSuccessMessage}
        editRowSuccessMessage={editRowSuccessMessage}
      />
    </>
  );
};

CsvUploader.propTypes = {
  buttonName: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
  backButtonName: PropTypes.string.isRequired,
  formName: PropTypes.string.isRequired,
  csvDataFormatter: PropTypes.func,
  handleSubmit: PropTypes.func.isRequired,
  headerConfiguration: PropTypes.array.isRequired,
  headersWithJsonFields: PropTypes.array.isRequired,
  requiredParams: PropTypes,
  validCsvHeaders: PropTypes.arrayOf(PropTypes.string),
  addNewRowFormName: PropTypes.array.isRequired,
  editRowFormName: PropTypes.array.isRequired,
  formItem: PropTypes.object,
  addNewRowSuccessMessage: PropTypes.string,
  editRowSuccessMessage: PropTypes.string,
};

export default CsvUploader;
